import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Cut = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.98 15.167a.8.8 0 0 0-1.099-.6L24.39 19.764l5.498-17.49c.2-.499-.1-.999-.6-1.099-.5-.1-1 .1-1.2.6L22.29 20.464l-7.097 1.999c.9-1.3 1.4-2.799 1.4-4.398 0-4.397-3.799-7.895-8.297-7.895C3.798 9.97 0 13.468 0 17.865c0 4.398 3.798 7.896 8.296 7.896.8 0 1.5-.2 2.2-.3.1 0 .4-.1.5-.1l10.595-2.998-3.1 9.894v.1c-.299.8-.499 1.699-.499 2.598 0 4.398 3.799 7.895 8.297 7.895 4.498 0 8.296-3.498 8.296-7.895 0-4.397-3.798-7.895-8.296-7.895-1.7 0-3.299.5-4.698 1.399l2.099-6.696 19.591-5.497c.5-.1.8-.7.7-1.099ZM1.8 17.865c0-3.298 2.798-6.096 6.496-6.096 3.599 0 6.498 2.798 6.498 6.096 0 2.599-1.8 4.897-4.299 5.797-.1 0-.3.1-.4.1-.6.2-1.199.2-1.799.2-3.598 0-6.497-2.799-6.497-6.097ZM26.288 28.96c3.598 0 6.497 2.798 6.497 6.096s-2.899 6.096-6.497 6.096c-3.599 0-6.498-2.798-6.498-6.096 0-.6.1-1.1.2-1.699 0-.1.1-.2.1-.3a6.707 6.707 0 0 1 6.198-4.097Z"
  }));
});
Cut.displayName = 'Cut';
Cut.defaultProps = {
  'aria-label': 'Cut'
};
export default Cut;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/Cut.js
// module id = 2916
// module chunks = 11